// BJT 第３部 読解部門 練習問題

// セクション２：表現読解問題 Q1–Q20

// セクション３：総合読解問題 Q21–Q40



const Q1 = {
  id: 1,
  number: '1番',
  type: 'expression_reading',
  difficulty: 'J2',
  section: 'reading_section2',
  knowledgePoint: '敬語：招待・誘いの丁寧表現「いかがでしょうか」vs「いただきますか」',
  scene: '取引先の担当者を食事に誘うメールの一文',
  lines: [
    '打ち合わせのあと、よろしければお食事でも（　　）。',
  ],
  options: ['いかがでしょうか', 'いただきますか', 'あげましょうか', 'めしあがりましょうか'],
  answer: 0,
  explanation:
    '「よろしければお食事でもいかがでしょうか」は取引先・目上の相手への誘いの最標準形。「いかが」は「どう」の丁寧語で相手の意向を伺う。「いただく」は「食べる・飲む」の謙譲語のため「いただきますか」では自分が食べるかどうかを相手に聞く形になり意味が逆転する。「あげましょうか」は親が子やペットに食事を与える文脈で使う語で対外的には失礼。「めしあがりましょうか」は「めしあがる」が「食べる・飲む」の尊敬語のため誘いの表現として成立しない。',
};

const Q2 = {
  id: 2,
  number: '2番',
  type: 'expression_reading',
  difficulty: 'J1+',
  section: 'reading_section2',
  knowledgePoint: '文法：「〜てまで」（目的のために極端な手段を用いる・非難の含意）',
  scene: '住民の反対運動を無視して工場建設を進める企業への批判記事の一節',
  lines: [
    '住民の強い反対を押し切っ（　　）工場を建設しようとする姿勢は、',
    '企業の社会的責任という観点から問題があると言わざるを得ない。',
  ],
  options: ['てこそ', 'てのみ', 'てまで', 'てだけ'],
  answer: 2,
  explanation:
    '「〜てまで」は「そこまでの手段を用いてでも」という意味で、目的達成のために過剰・不当な手段を取ることへの非難・批判の文脈で用いる。「反対を押し切ってまで工場を建設しようとする」で、その行為への批判が自然に成立する。「〜てこそ」は後ろにプラス評価の表現が続き「〜することで初めて意味がある」を表すため批判文脈に不適。「〜てのみ」は「〜して初めて成り立つ」という限定表現。「〜てだけ」は「そのことだけをして」という意味で批判のニュアンスがない。',
};

const Q3 = {
  id: 3,
  number: '3番',
  type: 'expression_reading',
  difficulty: 'J2',
  section: 'reading_section2',
  knowledgePoint: '慣用表現：「おかげ」（恩恵・プラスの原因）vs「せい」（マイナスの原因）',
  scene: 'プロジェクト成功の要因を上司に報告する社内メール',
  lines: [
    'チームメンバーのご協力の（　　）で、今回のプロジェクトは',
    '無事に完了することができました。',
  ],
  options: ['せい', 'おかげ', 'ごくろうさま', 'おせわさま'],
  answer: 1,
  explanation:
    '「おかげ」は良い結果をもたらした原因・恩恵を表す語で「〜のおかげで」は感謝とともに良い結果の原因を示す。「せい」は悪い結果の原因を表すため、プロジェクト成功という文脈では不適切。「ごくろうさま」は目下・同等の相手の労をねぎらう表現で上司へのメールでは失礼にあたる（上位者には「おつかれさまでした」を用いる）。「おせわさま」は一般的なビジネス表現ではなく文脈にも合わない。',
};

const Q4 = {
  id: 4,
  number: '4番',
  type: 'expression_reading',
  difficulty: 'J1+',
  section: 'reading_section2',
  knowledgePoint: '文法：「〜ざるを得ない」（不本意だが状況上そうせざるを得ない）',
  scene: 'コスト高騰により値上げを顧客に通知する案内文の一節',
  lines: [
    '昨今の原材料費・輸送コストの大幅な上昇により、',
    '誠に不本意ながら価格を改定せ（　　）状況となっております。',
  ],
  options: ['ずにはいられない', 'ざるを得ない', 'ないわけにはいかない', 'なくてはならない'],
  answer: 1,
  explanation:
    '「〜ざるを得ない」は「したくないが状況・外圧上そうせざるを得ない」という不可抗力のニュアンスを持ち、値上げ告知など不本意な措置を伝えるビジネス文書で最も適切。「〜ずにはいられない」は感情・衝動を抑えられないことを表し外部要因による強制とは異なる。「〜ないわけにはいかない」は義務・社会的規範の意味合いが強く、この文脈では「ざるを得ない」ほど謙虚さが伝わらない。「〜なくてはならない」は義務を直接的に述べる表現で、お客様への通知文の柔らかい文体とやや調和しない。',
};

const Q5 = {
  id: 5,
  number: '5番',
  type: 'expression_reading',
  difficulty: 'J2',
  section: 'reading_section2',
  knowledgePoint: '敬語：「ご覧いただく」（尊敬＋謙譲の複合的な表現）',
  scene: '会議資料を参加者に確認してもらう際の口頭説明',
  lines: [
    'お手元の資料の3ページ目を（　　）ながら、ご説明申し上げます。',
  ],
  options: ['見て', 'ご覧になり', 'ご覧いただき', '拝見し'],
  answer: 2,
  explanation:
    '「ご覧いただき」は「ご覧になる」（目上への尊敬語）＋「いただく」（恩恵を受ける謙譲語）を組み合わせた複合敬語表現で、参加者（聴衆）に資料を見てもらいながら説明するという場面に最適。「見て」は敬語でなく会議の公式場面には不適。「ご覧になり」は尊敬語のみで「もらう」という恩恵の意味が欠ける。「拝見し」は「見る」の謙譲語で自分が見る場合に用いるため、相手に見てもらう意図と逆方向になる。',
};

const Q6 = {
  id: 6,
  number: '6番',
  type: 'expression_reading',
  difficulty: 'J1',
  section: 'reading_section2',
  knowledgePoint: '文法接続：「〜に際して」（あるタイミング・機会に際して行う行為）',
  scene: '新規取引開始の挨拶状の書き出し',
  lines: [
    'このたびお取引を開始する（　　）、担当の山田と申します。',
    'どうぞよろしくお願い申し上げます。',
  ],
  options: ['に際して', 'をもって', 'にわたって', 'に対して'],
  answer: 0,
  explanation:
    '「〜に際して」は「〜というタイミング・機会に当たって」という意味の接続表現で、新規取引開始・入社・式典など重要な場面の挨拶文でよく使われる。「〜をもって」は手段・時点を示す（例：本状をもってご挨拶申し上げます）。「〜にわたって」は継続・範囲を示す（例：長期にわたって）。「〜に対して」は対象・対比を示す表現で挨拶の文脈に合わない。',
};

const Q7 = {
  id: 7,
  number: '7番',
  type: 'expression_reading',
  difficulty: 'J1+',
  section: 'reading_section2',
  knowledgePoint: '謙譲語：「伺う」（訪問・聞く・尋ねる）',
  scene: '取引先への訪問予定を伝えるメール',
  lines: [
    '来週水曜日の午後2時に貴社へ（　　）予定でございます。',
    'ご都合はいかがでしょうか。',
  ],
  options: ['参られる', '伺う', 'いらっしゃる', 'お越しになる'],
  answer: 1,
  explanation:
    '「伺う」は「訪問する・聞く・尋ねる」の謙譲語で、自社担当者が取引先（目上・社外）を訪問することを述べる場合の正しい形。「参られる」は「参る」（謙譲語）に尊敬の「られる」を付けた誤用で文法的に成立しない。「いらっしゃる」と「お越しになる」はいずれも尊敬語のため、自分の行動（訪問）を述べる際には使えない（相手の来訪を述べる場合に使う）。',
};

const Q8 = {
  id: 8,
  number: '8番',
  type: 'expression_reading',
  difficulty: 'J2',
  section: 'reading_section2',
  knowledgePoint: '文法：「〜かねます」（丁寧な不可・婉曲な断り）',
  scene: '規定外の割引要求への回答メール',
  lines: [
    '誠に恐縮ではございますが、ご要望の価格での対応は',
    '弊社の規定上（　　）。何卒ご了承くださいますようお願い申し上げます。',
  ],
  options: ['できません', 'むずかしいです', 'いたしかねます', 'ありません'],
  answer: 2,
  explanation:
    '「いたしかねます」は「かねる」（〜することが難しい・気が進まない）の謙譲形「いたし」を組み合わせた最も丁寧な断りの表現。直接的な否定を避けながらも明確に断意を伝えるビジネス文書の定番表現。「できません」は直接的すぎて顧客対応文書には硬すぎる。「むずかしいです」は口語的で格式のある回答文には不適切。「ありません」は文意が成立しない。',
};

const Q9 = {
  id: 9,
  number: '9番',
  type: 'expression_reading',
  difficulty: 'J1',
  section: 'reading_section2',
  knowledgePoint: '接続表現：「〜を踏まえ（て）」（先行情報を前提・根拠として）',
  scene: '市場調査結果を受けて戦略を検討する社内報告書の一節',
  lines: [
    '今回の市場調査の結果（　　）、来期の販売戦略を見直す必要があります。',
  ],
  options: ['を踏まえて', 'にもかかわらず', 'をきっかけとして', 'に反して'],
  answer: 0,
  explanation:
    '「〜を踏まえて」は「先行する事実・情報・経緯を前提・根拠として次の判断・行動を行う」という意味のビジネス文書頻出表現。調査結果→戦略見直しという論理的因果関係を表すのに最適。「〜にもかかわらず」は逆接で「結果に関係なく見直す」という意味になり文脈と合わない。「〜をきっかけとして」は契機を示すが「踏まえて」より論理的根拠の意味が弱い。「〜に反して」は「結果に逆らって」という意味になり不自然。',
};

const Q10 = {
  id: 10,
  number: '10番',
  type: 'expression_reading',
  difficulty: 'J1+',
  section: 'reading_section2',
  knowledgePoint: '文法：「〜かねてより」（以前から・以前より）',
  scene: '長期取引先への感謝の挨拶状',
  lines: [
    '（　　）格別のご愛顧を賜り、厚く御礼申し上げます。',
  ],
  options: ['かねてより', 'このたびは', '先日より', 'いまさら'],
  answer: 0,
  explanation:
    '「かねてより」は「以前から・かつてから」を意味する改まった書き言葉表現。長期取引先への感謝状の冒頭「かねてより格別のご愛顧を賜り」は定型的な礼状套語として機能する。「このたびは」は今回の特定の出来事を示す指示語で継続的な関係への感謝には不適。「先日より」は直近の短い期間を示すため長期取引への感謝として意味が弱い。「いまさら」は「今になって」という批判・皮肉のニュアンスがあり感謝文に使えない。',
};

const Q11 = {
  id: 11,
  number: '11番',
  type: 'expression_reading',
  difficulty: 'J2',
  section: 'reading_section2',
  knowledgePoint: '文法：「〜次第」（条件：〜になり次第すぐに）',
  scene: '発注品の入荷状況を顧客に伝えるメール',
  lines: [
    '商品が入荷（　　）、すぐにご連絡いたします。',
    'しばらくお待ちくださいますようお願い申し上げます。',
  ],
  options: ['してから', 'したら', 'し次第', 'すれば'],
  answer: 2,
  explanation:
    '「〜次第」は動詞の連用形に接続し「〜になったらすぐに」という即時性の条件を表すビジネス文書頻出の正式表現。「入荷し次第すぐにご連絡」は定型表現として機能する。「〜してから」は単純な先後関係を示し即時性の強調がない。「〜したら」は口語的な条件表現で書き言葉の格式に欠ける。「〜すれば」は仮定条件を示す接続で即時連絡のニュアンスが弱まる。',
};

const Q12 = {
  id: 12,
  number: '12番',
  type: 'expression_reading',
  difficulty: 'J1+',
  section: 'reading_section2',
  knowledgePoint: '敬語：「〜させていただく」（謙譲の許可求め・行為の丁寧表現）',
  scene: '取引先との打ち合わせで自社の提案を説明する冒頭の一文',
  lines: [
    '本日は弊社の新サービスについてご説明（　　）。',
  ],
  options: ['します', 'させてください', 'させていただきます', 'いたしましょう'],
  answer: 2,
  explanation:
    '「させていただきます」は自分の行為に相手の許可・恩恵があることを示す最も謙虚な謙譲表現で、取引先への説明・プレゼンの冒頭に用いる定番表現。「します」は丁寧語として正しいが取引先へのフォーマルな場面では謙譲度が不足。「させてください」は依頼表現で文末に使う場合は適切だが文末が断定的になりにくい。「いたしましょう」は勧誘・提案のニュアンスになり説明開始の宣言には意味がずれる。',
};

const Q13 = {
  id: 13,
  number: '13番',
  type: 'expression_reading',
  difficulty: 'J2',
  section: 'reading_section2',
  knowledgePoint: '文法：「〜とともに」（同時進行・並列の変化）',
  scene: '業界トレンドを分析した報告書の一節',
  lines: [
    'デジタル化が進む（　　）、従来型の営業手法の見直しも急務となっている。',
  ],
  options: ['とともに', 'にしたがって', 'につれて', 'のを機に'],
  answer: 0,
  explanation:
    '「〜とともに」はある変化と並行して別の変化が同時に進行することを示す接続表現。「デジタル化が進むとともに営業手法の見直しも進む」という2つの変化の同時進行を表すのに適切。「〜にしたがって・〜につれて」はどちらも「一方の変化に比例して他方も変化する」意味で文意は通じるが、「とともに」は二事象の並列的進行をより対等に示す。「〜のを機に」は「きっかけ」を示す表現で連続的変化の文脈には不自然。',
};

const Q14 = {
  id: 14,
  number: '14番',
  type: 'expression_reading',
  difficulty: 'J1',
  section: 'reading_section2',
  knowledgePoint: '文法：「〜に先立ち」（あることより前に行う準備・事前の行為）',
  scene: '新システム導入前の全社通知メール',
  lines: [
    '新システムの本格稼働（　　）、来月15日に操作研修を実施いたします。',
  ],
  options: ['に先立ち', 'に際して', 'に加えて', 'に反して'],
  answer: 0,
  explanation:
    '「〜に先立ち」は「〜よりも前に、〜に備えて行う事前の行為」を示す書き言葉の接続表現。「本格稼働に先立ち研修を実施」は時間的順序（研修→稼働）と事前準備の意味が明確に伝わる。「〜に際して」は「〜というタイミングに当たって」の意味で事前性の強調が弱い。「〜に加えて」は追加・付加の意味。「〜に反して」は逆接・対立を示すため文脈に合わない。',
};

const Q15 = {
  id: 15,
  number: '15番',
  type: 'expression_reading',
  difficulty: 'J1+',
  section: 'reading_section2',
  knowledgePoint: '文法：「〜にもかかわらず」（逆接：事実に反する結果・予想外の帰結）',
  scene: '決算報告書の業績分析部分の一節',
  lines: [
    '市場環境が厳しかった（　　）、今期の売上は前年比110%を達成した。',
  ],
  options: ['おかげで', 'にもかかわらず', 'ために', '結果として'],
  answer: 1,
  explanation:
    '「〜にもかかわらず」は「〜という条件・状況であるのに、それとは逆の（あるいは予想外の）結果になった」という逆接の接続詞。「市場環境が厳しい→通常は売上が落ちるはずだが→むしろ110%達成」という予想外のプラス評価を示す文脈に最適。「おかげで」は恩恵を示すため「厳しい市場環境のおかげで」では意味が不自然。「ために」は原因・目的を示す。「結果として」は帰結を示す表現で逆接のニュアンスがない。',
};

const Q16 = {
  id: 16,
  number: '16番',
  type: 'expression_reading',
  difficulty: 'J2',
  section: 'reading_section2',
  knowledgePoint: '敬語：「お〜いただく」（謙譲の複合敬語：〜してもらう）',
  scene: '顧客アンケートへの回答依頼メール',
  lines: [
    'ご多忙のところ恐れ入りますが、アンケートにご回答（　　）ますようお願い申し上げます。',
  ],
  options: ['して', 'してくださり', 'いただき', 'くださり'],
  answer: 2,
  explanation:
    '「ご回答いただきます」は「ご〜いただく」という謙譲の複合敬語で「回答してもらう」ことを最大限丁寧に表現する形。「ご回答いただきますようお願い申し上げます」はビジネスメールの依頼文末の最高礼儀表現として定型化している。「ご回答して」は接続が不自然。「ご回答してくださり」は「くださる」が尊敬語のため「ご〜して」との組み合わせが文法的に不安定。「ご回答くださり」も正しいが「ご回答いただき」の方がより謙虚な表現として慣用的に好まれる。',
};

const Q17 = {
  id: 17,
  number: '17番',
  type: 'expression_reading',
  difficulty: 'J1+',
  section: 'reading_section2',
  knowledgePoint: '文法：「〜を余儀なくされる」（望まない状況を強いられる）',
  scene: '自然災害による営業停止を顧客に通知する案内文',
  lines: [
    '今般の台風被害により、一部地域での配送業務の停止（　　）。',
    'ご不便をおかけすることを深くお詫び申し上げます。',
  ],
  options: ['をしなくてはなりませんでした', 'を余儀なくされております', 'をしてしまいました', 'をすることになりました'],
  answer: 1,
  explanation:
    '「〜を余儀なくされる」は「外部の力・状況によって望まない行為を強いられる」という意味の書き言葉表現で、災害・不可抗力による措置を顧客に説明する際に自社の意思ではなく状況によるものであることを示す最適な表現。謙虚かつ状況の客観的説明として機能する。「〜をしなくてはなりませんでした」は義務として述べる形で状況的強制の意味が弱い。「〜をしてしまいました」は完了・後悔のニュアンスで文書として軽すぎる。「〜をすることになりました」は決定を告げる表現で不可抗力の含意が薄い。',
};

const Q18 = {
  id: 18,
  number: '18番',
  type: 'expression_reading',
  difficulty: 'J2',
  section: 'reading_section2',
  knowledgePoint: '文法：「〜ものの」（逆接：事実を認めつつ別の問題点を示す）',
  scene: '新製品評価レポートの一節',
  lines: [
    '今回の新製品は機能面では高く評価されている（　　）、',
    '価格設定がターゲット層のニーズと合っていない点が課題として残っている。',
  ],
  options: ['ので', 'ものの', 'からこそ', 'だけあって'],
  answer: 1,
  explanation:
    '「〜ものの」は「〜という事実は認めるが、それとは別に問題・矛盾がある」という逆接の接続助詞。「機能は高評価だが価格設定が問題」という二面的評価を示すのに最適。「〜ので」は順接の因果関係を示すため「機能が高評価なので価格が問題」では論理が不自然。「〜からこそ」は「まさに〜だから」という強調の逆説で文意と合わない。「〜だけあって」は「さすがに〜するだけの理由がある」という肯定評価の表現で逆接にならない。',
};

const Q19 = {
  id: 19,
  number: '19番',
  type: 'expression_reading',
  difficulty: 'J1',
  section: 'reading_section2',
  knowledgePoint: '文法：「〜に基づいて」（根拠・基準に従って）',
  scene: '人事評価制度の変更を社員に通知する社内通達',
  lines: [
    '新制度は成果主義の原則（　　）設計されており、',
    '個人の業績目標達成度が評価に反映されます。',
  ],
  options: ['にもとづいて', 'にかかわらず', 'をはじめとして', 'にしては'],
  answer: 0,
  explanation:
    '「〜に基づいて（もとづいて）」は「〜を根拠・基準・原則として何かを行う」という意味の書き言葉接続表現。「成果主義の原則に基づいて設計」は制度の設計根拠を明示する際の定型表現。「〜にかかわらず」は「〜に関係なく」という無関係・例外を示す。「〜をはじめとして」は例示（AをはじめBCなど）を示す。「〜にしては」は「〜の割には・〜のわりに予想外」という軽い逆説で制度説明には不適切。',
};

const Q20 = {
  id: 20,
  number: '20番',
  type: 'expression_reading',
  difficulty: 'J1+',
  section: 'reading_section2',
  knowledgePoint: '文法：「〜を機に」（きっかけ・節目として新たな行動を起こす）',
  scene: '会社創立20周年を機に新事業に挑戦することを述べた社長メッセージ',
  lines: [
    '創立20周年（　　）、私どもは新たな事業領域への展開に踏み出すことといたしました。',
  ],
  options: ['に先立ち', 'をもって', 'を機に', 'にともなって'],
  answer: 2,
  explanation:
    '「〜を機に」は「〜という節目・きっかけをとらえて新しい行動・変化を起こす」という意味で、記念日・重要イベントを契機とした新方針の宣言によく使われる。「創立20周年を機に新事業へ踏み出す」は経営メッセージの定型表現として機能する。「〜に先立ち」は事前の準備行為を示す表現で新方針の宣言には意味がずれる。「〜をもって」は手段・時点・終了を示す（例：本状をもって通知します）。「〜にともなって」は付随的変化を示す接続で能動的な決意宣言には弱い。',
};

const Q21 = {
  id: 21,
  number: '21番',
  type: 'comprehensive_reading',
  difficulty: 'J1+',
  section: 'reading_section3',
  knowledgePoint: '社内文書読解：稟議書の目的・決裁フロー・承認条件の把握',
  scene: '新規ソフトウェア導入に関する稟議書の本文',
  lines: [
    '【稟議書】',
    '件名：顧客管理システム（CRM）導入の件',
    '起案者：営業部　田中一郎　　起案日：20XX年4月15日',
    '',
    '【提案の概要】',
    '現在の顧客管理は表計算ソフトによる個別管理であり、',
    'データの一元化および営業活動の効率化が急務となっている。',
    'ついては、クラウド型CRMシステムを導入し、部門横断的な',
    '情報共有体制を構築したい。',
    '',
    '【費用】初期費用：50万円　月額利用料：8万円（年間96万円）',
    '【効果】営業工数の20%削減・受注率5%向上を見込む',
    '【決裁条件】部長・経営企画部長・専務の順で承認が必要',
  ],
  options: ['この稟議書は営業部の部長だけが承認すれば導入できる', 'このシステムの導入費用は初年度合計146万円になる', '稟議書の目的は営業部内のみのデータ管理改善である', 'このシステム導入によりコスト削減のみが期待されている'],
  answer: 1,
  explanation:
    '初期費用50万円＋年間利用料96万円＝初年度合計146万円となり選択肢2が正しい。選択肢1は「部長・経営企画部長・専務の順で承認が必要」とあり部長だけでは不十分。選択肢3は「部門横断的な情報共有体制の構築」が目的とあり営業部内のみの改善ではない。選択肢4は「受注率5%向上」という売上増加効果も記載されておりコスト削減のみではない。稟議書読解では費用・承認者・効果の3点を正確に把握することが重要。',
};

const Q22 = {
  id: 22,
  number: '22番',
  type: 'comprehensive_reading',
  difficulty: 'J2',
  section: 'reading_section3',
  knowledgePoint: 'ビジネスメール読解：依頼内容・期限・添付書類の正確な把握',
  scene: '取引先から届いた見積もり依頼メール全文',
  lines: [
    '件名：新オフィス向け複合機リース見積もりのご依頼',
    '',
    '山田電機株式会社　営業部　御中',
    '',
    'お世話になっております。グローバル商事　総務部の鈴木でございます。',
    'このたび弊社では来月より新オフィスへ移転することになりました。',
    'それに伴い、複合機を3台リースにてご手配いただきたく存じます。',
    '機器の仕様については添付のシートをご参照ください。',
    '誠に恐縮ですが、今月末日までにお見積もりをお送りいただけますでしょうか。',
    '何卒よろしくお願い申し上げます。',
    '',
    '添付：仕様確認シート.xlsx',
  ],
  options: ['このメールの依頼内容は新オフィスの設計である', '見積もりの期限は来月の移転日である', '複合機は購入ではなくリースで3台必要としている', '機器の仕様はメール本文中に詳しく記載されている'],
  answer: 2,
  explanation:
    '「複合機を3台リースにてご手配」と明記されており選択肢3が正しい。選択肢1はオフィス設計ではなく複合機のリース見積もりの依頼。選択肢2の期限は「今月末日」であり来月の移転日ではない。選択肢4は仕様については「添付のシートをご参照」とあり本文ではなく添付ファイルに記載されている。ビジネスメール読解では依頼内容・期限・手段（購入かリースか）・情報の所在（本文か添付か）を区別して読む訓練が必要。',
};

const Q23 = {
  id: 23,
  number: '23番',
  type: 'comprehensive_reading',
  difficulty: 'J1+',
  section: 'reading_section3',
  knowledgePoint: 'ビジネス文書：お詫び状の構成・謝罪表現・再発防止策の読解',
  scene: '品質不良による納品ミスに関するお詫び状',
  lines: [
    '拝啓　貴社ますますご清栄のこととお喜び申し上げます。',
    '平素は格別のご愛顧を賜り、誠にありがとうございます。',
    '',
    'このたびは弊社より納品いたしました製品（品番：TK-2205）に',
    '品質上の不具合が発生し、多大なるご迷惑をおかけいたしましたことを',
    '深くお詫び申し上げます。',
    '',
    '原因を調査いたしましたところ、製造工程における検査手順の一部に',
    '不備があったことが判明いたしました。',
    '再発防止策として、全製品に対する二重検査体制を即時に導入するとともに、',
    '当該製品の無償交換を速やかに実施いたします。',
    '',
    '今後このようなことのないよう万全を期す所存でございます。',
    'なにとぞご了承くださいますようお願い申し上げます。',
    '敬具',
  ],
  options: ['不具合の原因は輸送中の破損であると説明している', '再発防止策として製品の二重検査体制導入と無償交換を行う', '不良品の返金対応を行うと述べている', 'このお詫び状は新製品の紹介を兼ねている'],
  answer: 1,
  explanation:
    '「二重検査体制を即時に導入するとともに、当該製品の無償交換を速やかに実施」と明記されており選択肢2が正しい。選択肢1は製造工程の検査手順の不備が原因とあり輸送中の破損ではない。選択肢3は「無償交換」であり返金とは異なる。選択肢4はお詫び状であり新製品紹介の要素は一切含まれていない。お詫び状読解では「原因・再発防止策・補償内容」の3点の正確な把握が重要。',
};

const Q24 = {
  id: 24,
  number: '24番',
  type: 'comprehensive_reading',
  difficulty: 'J2',
  section: 'reading_section3',
  knowledgePoint: '社外文書：契約書条文の読解（解約条件・違約金・期間）',
  scene: '業務委託契約書の中途解約に関する条項（第12条）',
  lines: [
    '第12条（契約の解除）',
    '1. 本契約の期間は契約締結日より1年間とし、期間満了の30日前までに',
    '   いずれかの当事者より書面による解約申し入れがない場合は、',
    '   同一条件でさらに1年間自動更新されるものとする。',
    '2. 甲が本契約を期間中に解除する場合は、解除希望日の60日前までに',
    '   乙へ書面にて通知しなければならない。',
    '3. 第2項の条件を満たさずに解除した場合、甲は残存期間の月額委託料',
    '   相当額を違約金として乙に支払わなければならない。',
  ],
  options: ['契約を自動更新しないためには期間満了の60日前に通知が必要', '期間中の解除には60日前までの書面通知が必要', '60日前通知なしに解除した場合でも違約金は発生しない', 'この契約は甲からのみ解約の申し入れができる'],
  answer: 1,
  explanation:
    '第12条第2項「解除希望日の60日前までに乙へ書面にて通知しなければならない」とあり選択肢2が正しい。選択肢1は自動更新を避けるための期限が「30日前」と明記されており60日前ではない（期間満了30日前までに通知）。選択肢3は第3項で60日前通知なしの解除には違約金が発生すると明記されており誤り。選択肢4は第1項に「いずれかの当事者より」とあり甲乙両者から申し入れできる。',
};

const Q25 = {
  id: 25,
  number: '25番',
  type: 'comprehensive_reading',
  difficulty: 'J1+',
  section: 'reading_section3',
  knowledgePoint: '議事録読解：決定事項・担当者・期限の正確な把握',
  scene: '営業戦略会議の議事録（抜粋）',
  lines: [
    '【営業戦略会議　議事録】',
    '日時：20XX年5月10日（水）14:00〜16:00',
    '出席者：田中部長、山田課長、鈴木・佐々木・林（各担当）',
    '',
    '【決定事項】',
    '1. 第2四半期の重点エリアを首都圏から東海・関西地域にシフトする。',
    '   担当：山田課長がチームを編成し、来月15日までに具体的行動計画を提出。',
    '2. 新規顧客開拓のためのウェビナーを来月末に開催する。',
    '   担当：鈴木が企画・進行を担当し、参加者100名を目標とする。',
    '3. 競合他社の動向分析レポートを月次で作成する。',
    '   担当：佐々木が毎月末に部長へ提出。',
  ],
  options: ['行動計画の提出期限は来月末である', '新規顧客開拓のウェビナーの担当者は佐々木である', '競合分析レポートは月次で田中部長に提出される', '重点エリアは首都圏への集中が決定した'],
  answer: 2,
  explanation:
    '「佐々木が毎月末に部長へ提出」とあり選択肢3が正しい。選択肢1は行動計画の提出期限が「来月末」ではなく「来月15日まで」と明記されており誤り。選択肢2のウェビナー担当は佐々木ではなく鈴木。選択肢4は重点エリアを首都圏から東海・関西へシフトする（離れる方向）とあり首都圏への集中は誤り。議事録読解では「誰が・何を・いつまでに」という3点セットを各決定事項ごとに正確に把握することが求められる。',
};

const Q26 = {
  id: 26,
  number: '26番',
  type: 'comprehensive_reading',
  difficulty: 'J2',
  section: 'reading_section3',
  knowledgePoint: 'ビジネス文書：社内規程（経費精算規定）の条件・例外・手続きの読解',
  scene: '経費精算規定（抜粋）',
  lines: [
    '第4条（交通費の取り扱い）',
    '1. 業務上の移動に要した交通費は実費で精算する。ただし、',
    '   タクシー利用は以下の条件を満たす場合にのみ認める。',
    '   ①終電後の帰社が必要な場合',
    '   ②公共交通機関が利用できない地域での移動の場合',
    '   ③緊急対応として上長の事前承認がある場合',
    '',
    '2. 出張時の交通費は事前に上長の承認を得た後、出張報告書とともに',
    '   申請すること。事後申請の場合、精算が認められないことがある。',
    '',
    '3. 領収書は5万円以上の場合には原本を、5万円未満の場合は',
    '   写し（コピー）でも可とする。',
  ],
  options: ['タクシーは業務であればいつでも利用・精算できる', '出張交通費の申請は事後でも必ず精算が認められる', '4万円の領収書は写しでも精算の申請に使用できる', '5万円以上の領収書は写しでも原本と同様に扱われる'],
  answer: 2,
  explanation:
    '第4条第3項「5万円未満の場合は写し（コピー）でも可」とあり4万円（5万円未満）は写しで申請できるため選択肢3が正しい。選択肢1はタクシーは3つの条件のいずれかを満たす場合のみ認められるため「いつでも」は誤り。選択肢2は「事後申請の場合、精算が認められないことがある」と明記されており必ず認められるわけではない。選択肢4は5万円以上は原本が必要であり写しは不可。',
};

const Q27 = {
  id: 27,
  number: '27番',
  type: 'comprehensive_reading',
  difficulty: 'J1+',
  section: 'reading_section3',
  knowledgePoint: 'メール読解：断りメールの構成・代替案の読解と筆者の意図把握',
  scene: '取引先からの共同プロジェクトの提案への回答メール',
  lines: [
    '件名：Re：共同プロジェクトのご提案について',
    '',
    'お世話になっております。ABC商事の中村でございます。',
    '',
    'この度はご提案をいただき、誠にありがとうございます。',
    '社内で慎重に検討いたしました結果、誠に恐縮ではございますが、',
    '現時点では参画が難しい状況でございます。',
    '',
    'その理由といたしましては、弊社では現在複数のプロジェクトが',
    '進行中であり、新たなプロジェクトへのリソース配分が',
    '困難な状況にあるためでございます。',
    '',
    'ただし、来期以降につきましては、改めてご相談させていただければ',
    '幸いに存じます。引き続きのご縁を大切にしてまいりたいと考えております。',
  ],
  options: ['このメールは共同プロジェクトへの参画を決定したことを伝えている', '断りの理由はプロジェクトの内容に問題があるためである', '現時点では断るが来期以降の相談の可能性を示している', '将来の取引関係を完全に打ち切ることを通知している'],
  answer: 2,
  explanation:
    '「現時点では参画が難しい」と断りつつ「来期以降につきましては改めてご相談させていただければ」と将来の可能性を示しており選択肢3が正しい。選択肢1は断りメールであり参画決定ではない。選択肢2の断り理由はプロジェクト内容の問題ではなく「複数プロジェクト進行中でリソースが不足」という自社事情。選択肢4は「引き続きのご縁を大切に」と述べており関係打ち切りではない。断りメールは「謝辞→断り→理由→代替案・将来の可能性」という構成を持つことが多い。',
};

const Q28 = {
  id: 28,
  number: '28番',
  type: 'comprehensive_reading',
  difficulty: 'J2',
  section: 'reading_section3',
  knowledgePoint: '報告書読解：数値・グラフデータの解釈と複数情報の照合',
  scene: '第1四半期売上報告書（要約）',
  lines: [
    '【第1四半期　部門別売上概況】',
    '',
    '全社売上合計：12億3,000万円（前年同期比：+8%）',
    '',
    '部門別実績（カッコ内は前年同期比）：',
    '・国内営業部　：6億2,000万円（+3%）',
    '・海外営業部　：4億1,000万円（+22%）',
    '・EC販売部　　：1億円（-15%）',
    '',
    '【所見】',
    '海外部門の大幅増が全社業績をけん引した一方、',
    'EC部門は競合他社のセール強化の影響を受け前年を割り込んだ。',
    '来期はEC部門の立て直しを最優先課題として取り組む。',
  ],
  options: ['全社売上は前年から8%減少した', 'EC販売部の売上は前年同期より増加した', '海外営業部の成長率が全部門で最も高い', '国内営業部の売上が全社売上の半分以上を占めている'],
  answer: 2,
  explanation:
    '海外営業部が+22%で最も高い成長率であり選択肢3が正しい。選択肢4も「国内営業部6億2,000万円÷全社12億3,000万円≒50.4%」で半分以上に見えるが、選択肢3の方が明確に正しいデータに基づいており正解は3。選択肢1は「+8%増加」であり減少ではない。選択肢2はEC販売部が「-15%」と減少している。報告書の数値問題では「増減の方向」「数値の大小比較」「割合の計算」を素早く行う練習が有効。',
};

const Q29 = {
  id: 29,
  number: '29番',
  type: 'comprehensive_reading',
  difficulty: 'J1+',
  section: 'reading_section3',
  knowledgePoint: '論説文読解：筆者の主張・根拠・問題意識の把握',
  scene: 'ビジネス誌のコラム「日本企業のグローバル人材育成」（抜粋）',
  lines: [
    '日本企業がグローバル競争を勝ち抜くためには、語学力だけでなく、',
    '異文化理解能力とクリティカル・シンキングを兼ね備えた人材の育成が',
    '急務である。',
    '',
    '従来の日本型研修では「正解を覚える」ことに重点が置かれてきた。',
    'しかし、変化の激しい国際ビジネスの現場では、正解のない問題に対して',
    '自ら仮説を立て、検証し、判断する能力こそが求められる。',
    '',
    '企業は即戦力を求めるあまり短期研修に偏りがちだが、',
    '真のグローバル人材育成には、最低3年から5年の継続的な投資が必要であると、',
    '筆者は考える。',
  ],
  options: ['筆者は従来の日本型研修の方法を高く評価している', '筆者は語学力さえあればグローバル人材として十分だと述べている', '筆者はグローバル人材育成に3〜5年の継続投資が必要だと主張している', '筆者は短期研修こそが最も効果的な人材育成方法だと述べている'],
  answer: 2,
  explanation:
    '「最低3年から5年の継続的な投資が必要であると、筆者は考える」と明示されており選択肢3が筆者の主張を正確に反映している。選択肢1は「正解を覚えることに重点が置かれてきた」と従来型研修の問題点を示しており高評価とは逆。選択肢2は「語学力だけでなく異文化理解とクリティカル・シンキングが必要」とあり語学力だけで十分とは述べていない。選択肢4は「短期研修に偏りがちだが」と問題点として指摘しており推奨していない。',
};

const Q30 = {
  id: 30,
  number: '30番',
  type: 'comprehensive_reading',
  difficulty: 'J2',
  section: 'reading_section3',
  knowledgePoint: '社内通知読解：変更内容・対象者・手続きの正確な把握',
  scene: '人事部からの福利厚生制度変更の社内通知',
  lines: [
    '【社内通知】　　　　　　　　　　　　人事部',
    '件名：育児休業・在宅勤務制度の改定について',
    '',
    '来月1日より、以下の通り制度を改定いたします。',
    '',
    '①育児休業対象年齢の拡大',
    '　現行：子が1歳になるまで　→　改定後：子が2歳になるまで',
    '',
    '②在宅勤務日数の上限変更',
    '　現行：週2日まで　→　改定後：週3日まで',
    '',
    '③申請手続き',
    '　本制度の利用を希望する方は、利用開始の2週間前までに',
    '　所定の申請書を人事部に提出してください。',
    '　なお、上長の承認が必要です。',
  ],
  options: ['育児休業は子が1歳になるまでという現行制度が維持される', '在宅勤務は改定後も週2日が上限である', '在宅勤務の申請は利用開始の1週間前までに行う必要がある', '在宅勤務制度を利用するには上長の承認が必要である'],
  answer: 3,
  explanation:
    '③申請手続きに「上長の承認が必要」と明記されており選択肢4が正しい。選択肢1は育児休業の対象年齢が「2歳まで」に拡大されており現行（1歳まで）は維持されない。選択肢2は在宅勤務の上限が「週3日」に変更されており週2日は旧制度。選択肢3は申請期限が「2週間前まで」であり1週間前ではない。改定通知読解では「現行vs改定後」の対比と手続き条件（期限・承認者）を正確に読み取ることが求められる。',
};

const Q31 = {
  id: 31,
  number: '31番',
  type: 'comprehensive_reading',
  difficulty: 'J1+',
  section: 'reading_section3',
  knowledgePoint: 'アンケート・調査報告読解：設問の意図・集計結果の解釈',
  scene: '社員満足度調査の結果報告書（抜粋）',
  lines: [
    '【20XX年度　社員満足度調査　結果報告（抜粋）】',
    '回答者数：全社員582名のうち521名（回答率89.5%）',
    '',
    '「現在の職場環境に満足していますか」',
    '　非常に満足：12%　　やや満足：38%　　普通：28%',
    '　やや不満：16%　　　非常に不満：6%',
    '',
    '満足度が低い理由（複数回答、上位3項目）：',
    '　1位　給与・賞与への不満（65%）',
    '　2位　業務量の多さ（52%）',
    '　3位　キャリアアップ支援の不足（41%）',
    '',
    '前年調査比：全体満足度（「満足」合計）は前年比3ポイント上昇',
  ],
  options: ['職場環境に「満足」と回答した割合は全体の50%を超えている', '不満の理由として最も多く挙げられたのは業務量の多さである', '全社員のうち回答しなかった社員は61名である', '全体満足度は前年より低下している'],
  answer: 2,
  explanation:
    '「非常に満足：12%＋やや満足：38%＝50%」は超えていないため選択肢1は誤り（ちょうど50%）。選択肢2の不満理由1位は「給与・賞与への不満65%」で業務量52%は2位であり誤り。選択肢3は「582名－521名＝61名が未回答」であり正しい計算。ただし選択肢4「前年より低下」は「前年比3ポイント上昇」と逆のため誤り。正解は選択肢3（61名未回答）。調査報告読解では「割合の計算」「順位の確認」「前年比の方向」を素早く確認することが必要。',
};

const Q32 = {
  id: 32,
  number: '32番',
  type: 'comprehensive_reading',
  difficulty: 'J2',
  section: 'reading_section3',
  knowledgePoint: 'プレスリリース読解：発表者・内容・時期・目的の正確な把握',
  scene: '新製品発売に関するプレスリリース（抜粋）',
  lines: [
    '【プレスリリース】',
    '20XX年6月1日',
    'テクノ産業株式会社',
    '',
    '件名：省エネ型空調システム「EcoAir Pro」発売のお知らせ',
    '',
    '当社は、このたび従来製品比で消費電力を40%削減した省エネ型業務用',
    '空調システム「EcoAir Pro」を、7月1日より全国の代理店を通じて',
    '販売開始いたします。',
    '',
    '本製品の希望小売価格は1台あたり85万円（税別）で、',
    '法人向け一括購入の場合は別途見積もりに対応いたします。',
    '',
    '環境負荷の低減と光熱費削減を両立させた本製品は、',
    '2050年のカーボンニュートラル達成に向けた企業の取り組みを',
    '支援するものです。',
  ],
  options: ['「EcoAir Pro」は6月1日より販売が開始される', 'この製品の消費電力は従来品の40%である', '法人向けの価格は一律85万円である', '販売は全国の代理店を通じて行われる'],
  answer: 3,
  explanation:
    '「全国の代理店を通じて販売開始」と明記されており選択肢4が正しい。選択肢1は発売日が「7月1日」であり6月1日はプレスリリースの発表日。選択肢2は「消費電力を40%削減」（つまり60%になる）であり、従来品の40%ではなく40%削減した製品（60%相当の消費電力）。選択肢3は法人向け一括購入は「別途見積もり」対応とあり一律ではない。プレスリリース読解では「発表日vs発売日」「割合の増減方向」「固定価格か見積もりか」の3点に注意が必要。',
};

const Q33 = {
  id: 33,
  number: '33番',
  type: 'comprehensive_reading',
  difficulty: 'J1+',
  section: 'reading_section3',
  knowledgePoint: '社内報・コラム読解：筆者の立場と主張・具体例の目的の把握',
  scene: '社内報のコラム「働き方改革の現場から」（抜粋）',
  lines: [
    '「残業ゼロ」を目指す取り組みを始めて2年が経過した。',
    '当初は「仕事が終わらない」という声も多かったが、',
    '業務の優先順位づけと会議の効率化を徹底した結果、',
    '一人あたりの残業時間は月平均38時間から12時間へと大幅に減少した。',
    '',
    '大切なのは、時間を減らすことが目的ではなく、',
    '限られた時間で最大の成果を出すという発想の転換である。',
    '「早く帰ることが目標」ではなく、「効率よく働くことで',
    'より充実した仕事と生活を実現する」ことが本質だと考える。',
  ],
  options: ['この取り組みの目標は残業時間をゼロにすることである', '筆者は早く帰ることそのものを働き方改革の本質と考えている', '残業時間は取り組み前に比べて月平均26時間減少した', '当初から全社員が賛成し取り組みはスムーズに進んだ'],
  answer: 2,
  explanation:
    '「38時間→12時間」で差は「38－12＝26時間の減少」であり選択肢3が正しい。選択肢1は「残業ゼロを目指す」という取り組みの目標名称だが、筆者は「時間を減らすことが目的ではない」と述べており残業ゼロ自体を目標とは考えていない。選択肢2は「早く帰ることが目標ではない」と明言しており誤り。選択肢4は「当初は「仕事が終わらない」という声も多かった」とあり全員賛成ではなかった。',
};

const Q34 = {
  id: 34,
  number: '34番',
  type: 'comprehensive_reading',
  difficulty: 'J2',
  section: 'reading_section3',
  knowledgePoint: 'ビジネスコラム読解：逆説的な論理展開・筆者の真意の読み取り',
  scene: 'ビジネス誌「顧客満足度と企業収益の関係」（抜粋）',
  lines: [
    '顧客満足度の向上が売上増加に直結するという前提は、',
    '必ずしも正しくない。むしろ、顧客の要求をすべて満たすことで',
    'コストが増大し、収益性が低下するケースも少なくない。',
    '',
    '重要なのは、すべての顧客に同水準のサービスを提供することではなく、',
    '収益への貢献度の高い優良顧客を特定し、そこへのリソースを',
    '重点配分することである。',
    '',
    '顧客ごとの収益性を可視化し、戦略的に対応を差別化することが、',
    '持続的な企業成長には不可欠であると筆者は主張する。',
  ],
  options: ['筆者は顧客全員に均等なサービスを提供することを推奨している', '顧客満足度の向上は常に売上増加につながると述べている', '優良顧客へのリソース集中と顧客ごとの戦略的対応を主張している', 'コストを削減するためにはサービスの質を下げるべきと述べている'],
  answer: 2,
  explanation:
    '筆者の主張は「収益貢献度の高い優良顧客を特定してリソースを重点配分し、顧客ごとに対応を差別化する」であり選択肢3が正しい。選択肢1は「すべての顧客に同水準のサービスを提供することではなく」と明言されており均等提供は否定されている。選択肢2は冒頭「必ずしも正しくない」と逆の主張がされている。選択肢4はサービスの質低下についての言及はなく本文の主旨と異なる。このような逆説を用いた論理展開では第1段落（従来説の否定）と第2・3段落（真の主張）の構造を把握することが重要。',
};

const Q35 = {
  id: 35,
  number: '35番',
  type: 'comprehensive_reading',
  difficulty: 'J1+',
  section: 'reading_section3',
  knowledgePoint: '手順書・マニュアル読解：条件分岐・例外処理の正確な把握',
  scene: '社内経費申請システムの操作マニュアル（抜粋）',
  lines: [
    '【経費申請の手順】',
    '',
    'ステップ1：社内ポータルにログインし「経費申請」をクリック',
    'ステップ2：申請区分を選択する（交通費・接待費・物品購入費など）',
    'ステップ3：必要事項を入力し、領収書の画像をアップロードする',
    'ステップ4：申請内容を確認後「提出」ボタンを押す',
    '',
    '※注意事項',
    '・1件あたり1万円以上の申請は、直属の上長の承認後に経理部へ転送される',
    '・1万円未満の申請は上長承認なく経理部が直接処理する',
    '・申請は支出日から30日以内に行うこと。期限超過の場合は',
    '　総務部長の特別承認が必要となる',
  ],
  options: ['5,000円の申請は直属の上長の承認が必要である', '25,000円の申請は上長承認を経て経理部に転送される', '申請期限は支出日から60日以内である', '期限超過の申請は受け付けてもらえない'],
  answer: 1,
  explanation:
    '「1万円以上の申請は直属の上長の承認後に経理部へ転送」とあり25,000円（1万円以上）は選択肢2の通りとなるため正しい。選択肢1は「1万円未満は上長承認なく経理部が直接処理」とあり5,000円（1万円未満）は上長承認不要のため誤り。選択肢3は申請期限が「30日以内」であり60日ではない。選択肢4は期限超過でも「総務部長の特別承認があれば」処理可能と読め、完全に受け付けないとは書いていない。マニュアル読解では「条件の閾値（1万円）」「例外処理の手続き」を正確に読むことが重要。',
};

const Q36 = {
  id: 36,
  number: '36番',
  type: 'comprehensive_reading',
  difficulty: 'J2',
  section: 'reading_section3',
  knowledgePoint: 'ニュース記事・業界レポート読解：因果関係・トレンドの把握',
  scene: '経済誌の記事「国内製造業のコスト構造変化」（抜粋）',
  lines: [
    '近年、円安の長期化と原材料費の高騰が重なり、国内製造業の',
    'コスト構造は大きく変容している。特に中小メーカーでは、',
    'コスト増を製品価格に転嫁しきれず、利益率の悪化が深刻化している。',
    '',
    'こうした状況を背景に、付加価値の高い製品開発へのシフトや、',
    '生産拠点の東南アジアへの移転を検討する企業が増加している。',
    'しかし、技術流出リスクや現地人材の確保難という課題も指摘されており、',
    '一律に海外移転を選択することが最善策とは言いきれない。',
  ],
  options: ['円安と原材料費高騰により大企業のみが影響を受けている', '生産拠点の東南アジア移転はすべての企業に最善の選択である', '中小メーカーはコスト増を製品価格に完全に転嫁できている', '海外移転には技術流出リスクや現地人材確保の課題がある'],
  answer: 3,
  explanation:
    '「技術流出リスクや現地人材の確保難という課題も指摘されており」と明記されており選択肢4が正しい。選択肢1は「特に中小メーカーで深刻」とあり大企業のみとは言っていない（中小に特に言及）。選択肢2は「一律に海外移転を選択することが最善策とは言いきれない」と明言しており全企業に最善とは逆の主張。選択肢3は「コスト増を製品価格に転嫁しきれず」とあり完全転嫁できていないことが問題とされており誤り。',
};

const Q37 = {
  id: 37,
  number: '37番',
  type: 'comprehensive_reading',
  difficulty: 'J1+',
  section: 'reading_section3',
  knowledgePoint: '企業理念・方針文書読解：キーワードの定義と具体的方針の把握',
  scene: 'ある企業のCSR報告書「環境方針」（抜粋）',
  lines: [
    '当社は「環境との共生」を企業理念の柱の一つとして掲げ、',
    '以下の3点を環境方針として定めています。',
    '',
    '1. 製品ライフサイクル全体を通じたCO2排出量の削減',
    '2. 廃棄物のゼロエミッション化（2030年目標）',
    '3. サプライチェーン全体での環境基準の遵守徹底',
    '',
    'これらの方針を実現するため、全事業所でのISO14001認証取得を',
    '2025年までに完了する計画です。また、取引先企業に対しても',
    '当社環境基準への適合を求めてまいります。',
  ],
  options: ['廃棄物ゼロエミッション化の目標年は2025年である', 'ISO14001認証取得は取引先企業のみに求めている', '環境方針の一つとしてサプライチェーン全体での環境基準遵守がある', 'この企業の環境方針は自社の製造工程のみを対象としている'],
  answer: 2,
  explanation:
    '「サプライチェーン全体での環境基準の遵守徹底」が環境方針の第3項として明記されており選択肢3が正しい。選択肢1の廃棄物ゼロエミッション目標は「2030年」であり2025年はISO14001認証取得の期限。選択肢2はISO14001を「全事業所で取得」し取引先にも基準への適合を求めるとあり取引先のみではない。選択肢4はサプライチェーン全体・取引先への要求も含まれており自社のみではない。企業方針文書では数値・年度・対象範囲の3点を各項目ごとに正確に読み取ることが必要。',
};

const Q38 = {
  id: 38,
  number: '38番',
  type: 'comprehensive_reading',
  difficulty: 'J2',
  section: 'reading_section3',
  knowledgePoint: '統計・グラフを含む文章の読解：数値解釈と本文との照合',
  scene: '人事部内部資料「採用動向分析レポート」（抜粋）',
  lines: [
    '【採用動向分析】',
    '当社の過去3年間の新卒採用実績を分析した結果、以下の傾向が確認された。',
    '',
    '・内定承諾率：　1年前60%→2年前55%→3年前52%（年々上昇傾向）',
    '・平均入社後定着率（3年後）：71%（業界平均68%を上回る）',
    '・採用コスト：1名あたり平均85万円（前年比10%増）',
    '・応募者の出身大学：文系58%、理系42%',
    '',
    '内定承諾率の上昇は採用ブランディング強化の成果と考えられる。',
    '一方、採用コストの増加への対応として、リファーラル採用の',
    '活用を今後推進する方針である。',
  ],
  options: ['内定承諾率は3年前より低下している', '3年後の定着率は業界平均を下回っている', '採用コストは1名あたり前年より増加している', '応募者は理系の割合の方が文系より多い'],
  answer: 2,
  explanation:
    '「採用コスト：前年比10%増」と明記されており選択肢3が正しい。選択肢1は内定承諾率が3年前52%→2年前55%→1年前60%と「年々上昇」であり低下は誤り。選択肢2は定着率71%が「業界平均68%を上回る」とあり下回るは誤り。選択肢4は文系58%・理系42%で文系の方が多いため「理系の方が多い」は誤り。この種の統計データ問題では「方向（増加か減少か）」「大小比較（上回るか下回るか）」「割合の大小」の3点を素早く確認する訓練が有効。',
};

const Q39 = {
  id: 39,
  number: '39番',
  type: 'comprehensive_reading',
  difficulty: 'J1+',
  section: 'reading_section3',
  knowledgePoint: 'ビジネス文書総合読解：複数文書の照合・情報の統合',
  scene: '会議招集メールと添付の議題リスト（2文書の組み合わせ）',
  lines: [
    '【文書A：メール本文】',
    '件名：第3回マーケティング定例会議のご案内',
    '来週木曜日14:00より第3回定例会議を開催いたします。',
    '議題は添付をご確認ください。資料は前日までにご準備ください。',
    '会場：本社5階第3会議室',
    '',
    '【文書B：添付議題リスト】',
    '1. 第2四半期キャンペーン実施結果の報告（担当：鈴木）',
    '2. 第3四半期予算配分案の審議（担当：山田）',
    '3. 新商品プロモーション方針の決定（担当：全員で討議）',
    '4. その他',
  ],
  options: ['会議の資料は当日の朝に準備すればよい', '第3四半期予算配分案は鈴木が担当する', '新商品プロモーション方針は全員での討議で決定する', '会議は本社4階で開催される'],
  answer: 2,
  explanation:
    '議題3「新商品プロモーション方針の決定（担当：全員で討議）」と明記されており選択肢3が正しい。選択肢1は「前日までにご準備」とあり当日朝ではない。選択肢2の第3四半期予算配分案の担当は山田であり鈴木ではない（鈴木は第2四半期キャンペーン報告）。選択肢4の会議室は「本社5階」であり4階ではない。複数文書の照合問題では「文書Aに書いてある情報」と「文書Bに書いてある情報」を区別しながら各選択肢を検証することが重要。',
};

const Q40 = {
  id: 40,
  number: '40番',
  type: 'comprehensive_reading',
  difficulty: 'J2',
  section: 'reading_section3',
  knowledgePoint: 'ビジネス長文読解：段落ごとの役割把握と全体の論旨の統合',
  scene: '月次経営レポート「デジタルトランスフォーメーション推進状況」（抜粋）',
  lines: [
    '当社のDX推進は第2フェーズに移行した。第1フェーズでは',
    '業務プロセスのデジタル化を中心に取り組み、',
    '紙ベースの業務の80%を電子化することに成功した。',
    '',
    '現在進行中の第2フェーズでは、蓄積されたデータを活用した',
    '意思決定の高度化を目標としている。具体的には、',
    '売上予測AIの試験運用を開始しており、来期中の全社展開を目指している。',
    '',
    '一方で、課題も明確になってきた。デジタル人材の不足と、',
    '部門間でのデータ連携が十分でない点である。',
    'これらの課題解決のため、専門人材の中途採用と部門横断の',
    'データ連携プロジェクトを並行して推進する方針である。',
  ],
  options: ['第1フェーズでは売上予測AIの試験運用を行った', '紙ベース業務の電子化は第2フェーズの成果である', '売上予測AIは来期中に全社展開を目指している', 'デジタル人材の不足は第1フェーズで解決済みである'],
  answer: 2,
  explanation:
    '「売上予測AIの試験運用を開始しており、来期中の全社展開を目指している」と明記されており選択肢3が正しい。選択肢1の売上予測AIは第2フェーズの取り組みであり第1フェーズでは「業務プロセスのデジタル化」が中心だった。選択肢2の紙ベース業務の80%電子化は第1フェーズの成果であり第2フェーズではない。選択肢4のデジタル人材不足は「現在の課題」として第2フェーズで表面化したものであり解決済みではない。長文読解では各段落の役割（第1段落：過去の成果、第2段落：現在の取り組み、第3段落：課題と対策）を把握してから設問に当たることが効率的。',
};



// ─── Export ───


export const expressionReading = [Q1, Q2, Q3, Q4, Q5, Q6, Q7, Q8, Q9, Q10, Q11, Q12, Q13, Q14, Q15, Q16, Q17, Q18, Q19, Q20];
export const comprehensiveReading = [Q21, Q22, Q23, Q24, Q25, Q26, Q27, Q28, Q29, Q30, Q31, Q32, Q33, Q34, Q35, Q36, Q37, Q38, Q39, Q40];
export const readingPractice = { expressionReading, comprehensiveReading };
